import React from "react";
import { FieldRenderProps } from "react-final-form";
import { FormFieldProps, Form, Label } from "semantic-ui-react";
import DatePicker from "react-date-picker";

interface IProps extends FieldRenderProps<Date, any>, FormFieldProps {}

const DateInput: React.FC<IProps> = ({
  input,
  width,
  placeholder,
  max,
  min,
  meta: { touched, error },
}) => {
  return (
    <Form.Field error={touched && !!error} width={width}>
      <p style={{color: 'gray', marginBottom: '0px'}}>{placeholder}</p>
      <DatePicker
        className="tracking-docs__date-picker"
        maxDate={max}
        minDate={min}
        value={input.value || null}
        onChange={input.onChange}
      />
      {touched && error && (
        <Label basic color="red">
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default DateInput;
